import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  StatusFormatter,
  columnsComplate,
  columnsUploadPDIOUT,
  columnsUploadRePDIOUT,
  columnsUploadRePDIOUTNotC,
  components,
  dateDefault,
  formLabelsTheme,
  formatDate,
  getValueOptions,
  iconError,
  selectStyles,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
  useStylesSelect,
  validatePost
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  addUploadFilePDIOUT,
  editInbound,
  editVehicle,
  editVehicleConfirmREPDIOUT,
  editVehicleConfrim,
  editVehicleRepdiout,
  fetchFileTemplate,
  fetchFileTemplateBlob,
  fetchIdInbound,
  fetchIdVehicleFind,
  fetchIdVehicleFindMaintenance,
  fetchVehicle,
  fetchVehicleMaintenance,
  removeVehicle,
  removeVehicleWorkFlow,
  removeVehicleWorkFlowRepdiout,
  selectIdInbound,
  selectInspection,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
} from "../inbound/inboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InputNumber from "../../utility/InputNumber";
import {
  prosesUpload,
  prosesUploadCancel,
} from "../miscellaneous/MiscellaneousSlice";
import { env } from "../../../env";
import {
  AddUploadFileRepdiout,
  fetchIdMaintenance,
  selectIdMaintenance,
} from "./maintenanceSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const RePDIOUTPage = ({
  active,
  paramFilter,
  setParamFilter,
  paramValue,
  setParamValue,
  value,
  setValue,
  formValues,
  setFormValues,
  show,
  setShow,
  showScan,
  setShowScan,
  showDetailDamage,
  setShowDetailDamage,
  create,
  setCreate,
  columnsInspection,
  setColumnsInspection,
  listInspection,
  setListInspection,
  detailDamage,
  setDetailDamage,
  rowInspection,
  setRowInspection,
  rowIndexInspection,
  setRowIndexInspection,
  inspectoinResult,
  setInspectoinResult,
}) => {
  const classes = useStyles();
  const classesSelect = useStylesSelect();

  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdMaintenance);
  const data = useSelector(selectVehicle);
  const dataInspetion = useSelector(selectInspection);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);
  const forceUpdate = useForceUpdate();

  const [status, setStatus] = useState("");
  const [force, setForce] = useState(false);
  const inputRef = useRef(null);

  const [tableData, setTableData] = useState([]);

  const [row, setRow] = useState(null);
  const [rowIndex, setRowIndex] = useState(null);
  const [formatExtraData, setFormatExtraData] = useState([]);

  const [vin, setVin] = useState("");
  const [von, setVon] = useState("");
  const [engineNo, setEngineNo] = useState("");
  const [mileage, setMileage] = useState("");
  const [keyNumber, setKeyNumber] = useState("");
  const [remarks, setRemark] = useState("");
  const [inbounRule, setInbounRule] = useState("N");

  const [scanFrom, setScanFrom] = useState("");
  console.log(formValues, "luar");

  useEffect(() => {
    // Reset on first load
    // if (inspectoinResult === "OK") {

    // }

    console.log("jalan");
    setFormValues({
      ...formValues,

      pdi_out_date: {
        value: formValues.pdi_out_date.value,
        error: false,
        required: inspectoinResult === "OK" ? "Y" : "N",
      },
    });
  }, [inspectoinResult]);

  useEffect(() => {
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
        // list: list,
        // listColumns: listDamage,
      };
    });

    setTableData(initData);
  }, [data]);

  useEffect(() => {
    // Add number
    if (force === true) {
      handleSearch();
      forceUpdate();
      setParamValue("");
      setParamFilter("");
      setForce(false);
    }
  }, [force]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setParamFilter("");
    } else {
      setParamFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let result;
    let params = {};

    if (value === 0) {
      result = "5313,5320,5321";
    } else if (value === 1) {
      result = "5323";
    } else if (value === 2) {
      result = "5322";
    }

    params.maintenance_id = id;
    params[paramFilter] = paramValue;
    params.vehicle_status = result;
    params.is_planned = "Y,N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleMaintenance(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let result;
      let params = {};

      if (value === 0) {
        result = "5313,5320,5321";
      } else if (value === 1) {
        result = "5323";
      } else if (value === 2) {
        result = "5322";
      }

      params.maintenance_id = id;
      params[paramFilter] = paramValue;
      params.vehicle_status = result;
      params.is_planned = "Y,N";
      params.pageNo = page;
      params.pageSize = sizePerPage;

      try {
        const response = await dispatch(fetchVehicleMaintenance(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableData(result);
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const actionFormatterInspection = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={() => {
                const initData = row.detail.map((item, index) => {
                  return {
                    ...item,
                    no: index + 1,
                  };
                });

                setDetailDamage(initData);

                setRowInspection(row);
                setRowIndexInspection(rowIndex);

                setShowDetailDamage(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
              </span>
            </div>
          </OverlayTrigger>
        </div>
      </>
    );
  };
  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {row.vehicle_status !== "5313" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={() => {
                  const initData = row.listInspection.map((item, index) => {
                    return {
                      ...item,
                      no: index + 1,
                    };
                  });

                  const result = row.listColumn.map((item) => {
                    return {
                      text: item,
                      dataField: item,
                      // editable: false,
                    };
                  });

                  const finalResult = [
                    {
                      text: "Category",
                      dataField: "category_name",
                    },
                    {
                      text: "Inspection Point",
                      dataField: "name",
                    },
                    ...result,
                    {
                      dataField: "actions",
                      text: "Actions",
                      formatter: actionFormatterInspection,
                    },
                  ];
                  setRow(row);
                  setRowIndex(rowIndex);
                  setListInspection(initData);
                  setColumnsInspection(finalResult);

                  setFormValues({
                    ...formValues,
                    vin: {
                      value: row.vin,
                      error: false,
                      required: "Y",
                    },
                    von: {
                      value: row.von,
                      error: false,
                      required: "Y",
                    },
                    remarks: {
                      value: row.remark_repdiout,
                      error: false,
                      required: "N",
                    },
                    pdi_out_date: {
                      value: row.maintenance_pdi_out_date,
                      error: false,
                      required:
                        row.maintenance_inspection_result === "OK" ? "Y" : "N",
                    },
                  });
                  // setVon(row.von);
                  setEngineNo(row.engine_no);
                  setMileage(row.mileage);
                  setKeyNumber(row.key_no);
                  setInspectoinResult(row.maintenance_inspection_result);
                  setRemark(row.remarks);
                  setInbounRule(row.inbound_rule);
                  setCreate(false);
                  setShow(true);
                }}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  {value === 1 ? (
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")}
                    />
                  ) : (
                    <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                  )}
                </span>
              </div>
            </OverlayTrigger>
          )}

          {row.vehicle_status !== "5313" && (
            <>
              {value !== 1 && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={(e) => handleDelete(e, row)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },

    {
      text: "From Location",
      dataField: "from_location_repdiout",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "To Location",
      dataField: "to_location_repdiout",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "PDI-Out Date",
      dataField: "maintenance_pdi_out_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
      formatter: formatDate,
    },
    {
      text: "PDI- Out Remarks",
      dataField: "remark_repdiout",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "PDI- Out Result",
      dataField: "maintenance_inspection_result",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "User",
      dataField: "repdiout_updatedby",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "60px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    if (parseFloat(row.value) > parseFloat(row.max_weight)) {
      row.value = row.max_weight;
      forceUpdate();
      return true;
    } else if (parseFloat(row.value) < 0) {
      row.value = 0;
      forceUpdate();
      return true;
    }
  };

  const inputValue = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        step="any"
        className="input-box-table"
        value={parseFloat(row.value)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };

  const columnsDetailDamage = [
    {
      text: "Name",
      dataField: "name",
      editable: false,
    },

    {
      text: "Value",
      dataField: "value",
      formatter: inputValue,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
    },
  ];

  const handleClose = () => {
    setFormValues({
      vin: {
        value: "",
        error: false,
        required: "Y",
      },
      von: {
        value: "",
        error: false,
        required: "N",
      },
      remarks: {
        value: "",
        error: false,
        required: "N",
      },
      pdi_out_date: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setInspectoinResult("OK");

    setShow(false);
    setRow(null);
  };

  const handleCloseScan = () => {
    setScanFrom("");
    setShowScan(false);
  };

  const handleCloseDetailDamage = () => {
    setShowDetailDamage(false);
  };

  const handleSaveDetailDamage = () => {
    const result = {
      ...rowInspection,
      detail: [...rowInspection.detail],
    };

    const _detailDamage = [...detailDamage];

    _detailDamage.forEach((item) => {
      result[item.name] = item.value;
      const detailIndex = result.detail.findIndex(
        (detail) => detail.name === item.name
      );
      if (detailIndex !== -1) {
        const detailItem = { ...result.detail[detailIndex] };
        detailItem.value = item.value;
        result.detail[detailIndex] = detailItem;
      } else {
        result.detail.push(item);
      }
    });

    const updatedListInspection = [...listInspection];
    updatedListInspection[rowIndexInspection] = result;

    const updatedRow = {
      ...row,
      listInspection: updatedListInspection,
    };

    setListInspection(updatedListInspection);
    setRow(updatedRow);
    setShowDetailDamage(false);
  };

  const handleSave = async (status) => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }
    const vehicleInspects = listInspection.reduce((result, item) => {
      item.detail.forEach((detailItem) => {
        result.push({
          name: detailItem.name,
          damagecondition_id: detailItem.damagecondition_id,
          max_weight: detailItem.max_weight,
          value: detailItem.value,
          pref_damagecondition_id: detailItem.pref_damagecondition_id,
          pref_inspectionpoint_id: item.pref_inspectionpoint_id,
          preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
          status: 5321,
          remarks_perpoint: item.remarks_perpoint,
        });
      });
      return result;
    }, []);

    let params;

    if (create === true) {
      params = {
        maintenance_id: id,
        vin: formValues.vin.value,
        von: formValues.von.value,
        inspection_result: inspectoinResult,
        remarks: formValues.remarks.value,
        preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
        vehicleInspects: inspectoinResult === "OK" ? null : vehicleInspects,
        vehicle_status: inspectoinResult === "OK" ? "5320" : "5321",
        pdi_out_date:
           formValues.pdi_out_date.value ,
        maintenance_date:
          formValues.pdi_out_date.value ,
        inspection_date:
          formValues.pdi_out_date.value ,
      };
    } else {
      const code = inspectoinResult === "OK" ? "5320" : "5321";
      const statusCode = code === row.vehicle_status ? null : code;
      params = {
        maintenance_id: id,
        vin: formValues.vin.value,
        von: formValues.von.value,
        inspection_result: inspectoinResult,
        remarks: formValues.remarks.value,
        vehicle_id: row !== null ? row.vehicle_id : "",
        preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
        vehicleInspects: inspectoinResult === "OK" ? null : vehicleInspects,
        vehicle_status: code,
        pdi_out_date:
          formValues.pdi_out_date.value ,
        maintenance_date:
          formValues.pdi_out_date.value ,
        inspection_date:
          formValues.pdi_out_date.value ,
      };
    }

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleRepdiout(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleClose();
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleSaveConfrim = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const params = {
      maintenance_id: id,
      vin: formValues.vin.value,
      von: formValues.von.value,
      inspection_result: inspectoinResult,
      remarks: formValues.remarks.value,
      preferences_id: dataInspetion === null ? "" : dataInspetion.preferences_id,
      vehicleInspects: null,
      vehicle_status: "5320",
      maintenance_date: formValues.pdi_out_date.value,
      pdi_out_date: formValues.pdi_out_date.value,
      inspection_date: formValues.pdi_out_date.value,
    };
    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleRepdiout(params));
      if (response.payload.status === 200) {
        const responseConfirm = await dispatch(
          editVehicleRepdiout({
            ...params,
            vehicle_status: "5323",
          })
        );

        if (responseConfirm.payload.status === 200) {
          const action = await showSuccessDialog(
            responseConfirm.payload.data.message
          );
          await dispatch(fetchIdMaintenance(id));
          await handleClose();
          await handleSearch();
        } else {
          await handleClose();
          showErrorDialog(responseConfirm.payload.data.message);
        }
      } else {
        await handleClose();

        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      await handleClose();

      console.log(error.message);
    }
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
    forceUpdate();
    setForce(true);
  };

  const handleConfirm = async () => {
    const params = {
      maintenance_id: id,
      vehicle_status: "5323",
    };

    console.log(params, "params");
    try {
      const response = await dispatch(editVehicleConfirmREPDIOUT(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdInbound(id));
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDelete = async (e, row) => {
    const params = [
      {
        vehicle_id: `${row.vehicle_id}`,
        document_id: id,
      },
    ];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeVehicleWorkFlowRepdiout({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const handleModalEntered = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleFind = async () => {
    if (scanFrom === "") {
      return showDialog("Please scan or enter code");
    }
    const params = `${scanFrom}?document_id=${id}`;
    try {
      const response = await dispatch(fetchIdVehicleFindMaintenance(params));

      if (response.payload.status === 200) {
        const dataId = response.payload.data.data;
        setFormValues({
          ...formValues,

          vin: {
            value: dataId.vin,
            error: false,
            required: "Y",
          },
          von: {
            value: dataId.von,
            error: false,
            required: "N",
          },
          remarks: {
            value: dataId.remark_repdiout,
            error: false,
            required: "N",
          },
          pdi_out_date: {
            value: dataId.maintenance_pdi_out_date,
            error: false,
            required: "Y",
          },
        });

        setInspectoinResult(dataId.maintenance_inspection_result);

        const initData =
          dataId.listInspection === null
            ? []
            : dataId.listInspection.map((item, index) => {
                return {
                  ...item,
                  no: index + 1,
                };
              });

        const result =
          dataId.listColumn === null
            ? []
            : dataId.listColumn.map((item) => {
                return {
                  text: item,
                  dataField: item,
                  // editable: false,
                };
              });

        const finalResult = [
          {
            text: "Category",
            dataField: "category_name",
          },
          {
            text: "Inspection Point",
            dataField: "name",
          },
          ...result,
          {
            dataField: "actions",
            text: "Actions",
            formatter: actionFormatterInspection,
          },
        ];
        // Assuming you have new values or variables
        const newRow = row; /* your new value */
        const newRowIndx = rowIndex; /* your new value */
        const newInitData = initData; /* your new value */
        const newFinalResult = finalResult; /* your new value */

        // Update the state with the new values
        setRow(newRow);
        setRowIndex(newRowIndx);
        setListInspection(newInitData);
        setColumnsInspection(newFinalResult);

        setShowScan(false);
        setCreate(true);
        setShow(true);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // upload file
  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [rowUpload, setRowUpload] = useState(null);
  const [showUploadView, setShowUploadView] = useState(false);

  const [showUpload, setShowUpload] = useState(false);

  const handleCloseUpload = () => {
    setShowUpload(false);
    setFile(null);
    setFileName("Upload Template File");
  };
  const handleCloseUploadView = () => {
    setShowUploadView(false);
    setRowUpload(null);
  };

  const handleUpload = async () => {
    // if (file) {
    //   return showErrorDialog("Please Input");
    // }
    const params = {
      id: id,
      file: file,
    };
    try {
      const response = await dispatch(AddUploadFileRepdiout(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdMaintenance(id));
        await handleCloseUpload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProses = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUpload(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdMaintenance(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleProsesCancel = async () => {
    const params = {
      misc_header_id: rowUpload.misc_header_id,
    };
    try {
      const response = await dispatch(prosesUploadCancel(params));

      console.log(response, "response");

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdMaintenance(id));
        await handleCloseUploadView();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDownload = async () => {
    const params = {
      id: id,
      type: "MAINTENANCE_REPDIOUT",
    };
    try {
      const response = await dispatch(fetchFileTemplate(params));
      if (response.payload.status === 200) {
        const response = await dispatch(fetchFileTemplateBlob(params));
        if (response.payload.status === 200) {
          const blob = new Blob([response.payload.data], {
            type: "application/xlsx",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "MAINTENANCE_REPDIOUT.xlsx";
          link.click();
        }
      } else {
        showErrorDialog(response.payload.data.message);
        console.log("else");
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div>
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      </div>
    );
  };

  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardBody>
          <div className="d-flex mb-5 mt-5">
            <div className="p-2">
              <Button
                className="my-btn-primary-dark "
                onClick={(e) => setShowScan(true)}
              >
                Input Details
              </Button>
            </div>
            <div className="mr-auto p-2 ">
              <Button
                className="my-btn-primary-dark "
                onClick={(e) => setShowUpload(true)}
              >
                Upload Details
              </Button>
            </div>
            <div className="p-2">
              <Button variant="outline-primary" onClick={handleConfirm}>
                Confirm
              </Button>
            </div>
          </div>
          <>
            <Tabs
              value={value}
              onChange={handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
              fullWidth
            >
              <Tab label={`Planned Vehicles`} />
              <Tab label={`Confirmed Vehicles`} />
              <Tab label={`Cancelled For Vehicles`} />
            </Tabs>
            {/*  Planned Vehicles*/}
            {value === 0 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 1 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            {value === 2 && (
              <div className="mb-3">
                <div className="d-flex">
                  <div className="p-2 mt-3">Search By</div>
                  <div className="p-2" style={{ width: "180px" }}>
                    {" "}
                    <Select
                      options={vehiclesOptions}
                      value={getValueOptions(paramFilter, vehiclesOptions)}
                      placeholder="Select"
                      onChange={handleChangeVehicles}
                      required
                    />
                  </div>
                  <div className="p-2">
                    <Form.Control
                      type="text"
                      placeholder=""
                      onChange={(e) => setParamValue(e.target.value)}
                      value={paramValue}
                    />
                  </div>
                  <div className="p-2">
                    {" "}
                    <Button
                      variant="primary"
                      onClick={(e) => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>
                  </div>
                </div>

                {/* table */}

                <BootstrapTable
                  remote
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="vehicle_id"
                  data={tableData}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  onTableChange={handleTableChange}
                  hover
                >
                  <PleaseWaitMessage entities={loading ? null : data} />
                  <NoRecordsFoundMessage entities={loading ? null : data} />
                </BootstrapTable>
              </div>
            )}
            <hr />
            <div className="mb-3">
              <p className="font-weight-boldest">File Upload Progress</p>
              <Row>
                <Col md={4}>
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="no"
                    data={
                      dataId.tableUploadREPDIOUTs === null
                        ? []
                        : dataId.tableUploadREPDIOUTs
                    }
                    columns={columnsFile}
                    hover
                  />
                </Col>
              </Row>
            </div>
          </>
        </CardBody>
      </Card>

      <>
        {/* Modal Inspection */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              {row === null ? "Input" : "Update"} Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="VIN"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="vin"
                    value={formValues.vin.value}
                    onChange={handleChange}
                    error={formValues.vin.error}
                    helperText={
                      formValues.vin.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                    disabled
                  />
                  <TextField
                    id="Inspection Result"
                    select
                    label="Inspection Result"
                    defaultValue="ok"
                    size="small"
                    fullWidth
                    className={classes.margin}
                    onChange={(e) => setInspectoinResult(e.target.value)}
                    value={inspectoinResult}
                    disabled={value === 1 ? true : false}
                  >
                    <MenuItem key={1} value={"OK"}>
                      OK
                    </MenuItem>
                    <MenuItem key={1} value={"NG"}>
                      NG
                    </MenuItem>
                  </TextField>
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Remarks"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="remarks"
                    onChange={handleChange}
                    value={formValues.remarks.value}
                    inputProps={{ maxLength: 150 }}
                    disabled={value === 1 ? true : false}
                  />
                  {/*{inspectoinResult === "OK" && (*/}
                    <RedditTextField
                      required
                      label="PDI - OUT Date"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="datetime-local"
                      fullWidth
                      name="pdi_out_date"
                      value={formValues.pdi_out_date.value}
                      onChange={handleChange}
                      helperText={
                        formValues.pdi_out_date.error ? (
                          <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                            {iconError} {"This field is required"}
                          </FormHelperText>
                        ) : (
                          ""
                        )
                      }
                    />
                  {/*)}*/}
                </Col>
              </Row>
            </ThemeProvider>
            {inspectoinResult === "NG" && (
              <div>
                <p className="font-weight-boldest">Vehicle Inspection Result</p>

                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  keyField="name"
                  data={listInspection}
                  columns={columnsInspection}
                  hover
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {value !== 2 && (
              <>
                <Button variant="primary" onClick={(e) => handleSave("save")}>
                  Save
                </Button>
                {inspectoinResult === "OK" && (
                  <Button variant="primary" onClick={handleSaveConfrim}>
                    Confirm
                  </Button>
                )}
              </>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showDetailDamage}
          onHide={handleCloseDetailDamage}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Input Damage
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Category"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="Mileage"
                    value={
                      rowInspection === null ? "" : rowInspection.category_name
                    }
                    disabled
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    label="Inspection Point"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    type="text"
                    size="small"
                    fullWidth
                    name="Mileage"
                    value={rowInspection === null ? "" : rowInspection.name}
                    disabled
                  />
                </Col>
              </Row>
            </ThemeProvider>

            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              keyField="no"
              data={detailDamage}
              columns={columnsDetailDamage}
              hover
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
              })}
            ></BootstrapTable>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseDetailDamage}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveDetailDamage}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>

        {/* scann */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showScan}
          onHide={handleCloseScan}
          onEntered={handleModalEntered}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Scan or Enter Code
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ThemeProvider theme={formLabelsTheme}>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.Control
                    ref={inputRef}
                    type="text"
                    value={scanFrom}
                    onChange={(e) => setScanFrom(e.target.value)}
                  />
                </Col>
              </Row>
            </ThemeProvider>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseScan}>
              Close
            </Button>
            <Button variant="primary" onClick={handleFind}>
              Find
            </Button>
          </Modal.Footer>
        </Modal>

        {/* upload */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={showUpload}
          onHide={handleCloseUpload}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter text-white">
              Upload Re PDI -OUT Details
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-5">
              <h5 className="font-weight-boldest">File</h5>

              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <Form.File
                    type="file"
                    id="file_fpre"
                    custom
                    label={fileName}
                    onChange={(e) => {
                      setFile(e.target.files[0]);
                      setFileName(e.target.files[0].name);
                    }}
                    accept=".xlsx, .XLSX"
                  />
                </Col>
                <Col>
                  <Button
                    variant="primary"
                    onClick={handleUpload}
                    className="mr-5 "
                  >
                    Upload
                  </Button>

                  <Button variant="outline-primary" onClick={handleDownload}>
                    Download Template
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseUpload}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {/* upload View */}
        {rowUpload && (
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={showUploadView}
            onHide={handleCloseUploadView}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Upload Vehicle Information Status
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div class="d-flex mb-5">
                <div class="p-2 mr-auto font-weight-boldest ">
                  Uploaded Vehicles Data from file "{rowUpload.file_name}"
                </div>
                <div class="p-2 font-weight-boldest">
                  Status :{rowUpload.status}{" "}
                </div>
              </div>
              {rowUpload.status === "Uploaded" && (
                <Row className="ml-2 mb-5">
                  <Button
                    variant="primary"
                    className="mr-5"
                    onClick={handleProses}
                  >
                    Process Data
                  </Button>
                  <Button variant="danger" onClick={handleProsesCancel}>
                    Cancel Process Data
                  </Button>
                </Row>
              )}

              <>
                <div
                  className=" "
                  style={{
                    maxHeight: "600px",
                    overflowY: "scroll",
                  }}
                >
                  <BootstrapTable
                    wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                    keyField="no"
                    data={rowUpload !== null ? rowUpload.data : []}
                    columns={
                      rowUpload.status !== "Completed"
                        ? columnsUploadRePDIOUTNotC
                        : columnsUploadRePDIOUT
                    }
                    hover
                  />
                </div>
              </>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseUploadView}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    </>
  );
};
